export enum NotificationSortBy {
  TASK_DUE_DAY_ASC = 'TASK_DUE_DAY_ASC',
  TASK_UPDATED_AT_DESC = 'TASK_UPDATED_AT_DESC'
}

export enum OverviewProgressPeriod {
  TODAY = '1',
  THIS_WEEK = '2',
  THIS_MONTH = '3'
}

export enum NumberFilterEnum {
  SEARCH = 'SEARCH',
  BY_FM = 'BY_FM',
  BY_TYPE = 'BY_TYPE',
  SORT_BY = 'SORT_BY',
  DATE_RANGE = 'DATE_RANGE'
}
